import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getCouponByRefUserId } from '../couponService'

export const useAffiliateCoupons = (refUserId?: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.AFFILIATE, 'coupons', refUserId],
    queryFn: () => getCouponByRefUserId(refUserId!),
    enabled: !!refUserId,
  })
}
